module.exports = __webpack_public_path__ + "static/media/thumbs-down-outline.bd01d67f.svg";